import { render, staticRenderFns } from "./GroupPermissionsForm.vue?vue&type=template&id=e9c818be&scoped=true&"
import script from "./GroupPermissionsForm.vue?vue&type=script&lang=js&"
export * from "./GroupPermissionsForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupPermissionsForm.vue?vue&type=style&index=0&id=e9c818be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c818be",
  null
  
)

export default component.exports